import PropTypes from 'prop-types'
import { createContext, useState, useEffect } from 'react'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { setTokenGetter } from '../servicios/httpService'
import * as loginService from '../servicios/loginService'
import * as usuarioService from '../servicios/usuarioService'

export const LoginContext = createContext()

export const LoginProvider = (props) => {
  const [token, setToken] = useState('')
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  const [loginDataContext, setLoginDataContext] = useState({
    tipo: '',
    nombre: '',
    apellido: '',
    registradoParticular: false,
    tipoUsuario: '',
    idUsuario: null,
    cuit: ''
  })

  const buscarDatosUsuario = async (idUsuario) => {
    if (idUsuario) {
      try {
        const { data } = await usuarioService.buscarPorId(parseInt(idUsuario))
        updateUserData({
          nombre: data.nombre,
          apellido: data.apellido,
          tipo: data.tipo,
          tipoUsuario: data.tipoUsuario,
          registradoParticular: data.registradoParticular,
          idUsuario: data.idUsuario,
          cuit: data.cuit
        })
      } catch (error) {
        const mensaje = `Ocurrió un error al obtener los datos del usuario.`
        toastErrorLog(error, mensaje, 'usuario')
      }
    }
  }

  // Initialize context from localStorage on app start
  useEffect(() => {
    const storedToken = localStorage.getItem('jwt')
    const idUsuario = localStorage.getItem('idUsuario')
    buscarDatosUsuario(idUsuario)

    if (storedToken) {
      setToken(storedToken)
      setIsAuthenticated(true)
      setTokenGetter(() => storedToken)
    }
  }, [])

  const setLoginData = (data) => {
    const {
      token: tokenEBM,
      refreshToken,
      empid,
      usuario,
      idUsuario,
      nombre,
      apellido,
      tipo,
      tipoUsuario,
      registradoParticular,
      cuit
    } = data

    // Set authentication tokens
    setLocalStorage(tokenEBM, refreshToken, usuario, empid, idUsuario)

    // Update user context with validated data
    updateUserData({
      nombre,
      apellido,
      tipo,
      tipoUsuario,
      registradoParticular,
      idUsuario,
      cuit
    })
  }

  const setLocalStorage = (token, refreshToken, usuario, empid, idUsuario) => {
    setToken(token)
    setIsAuthenticated(true)
    // Only store essential auth data in localStorage
    localStorage.setItem('jwt', token)
    localStorage.setItem('refreshToken', refreshToken)
    localStorage.setItem('usuario', usuario)
    localStorage.setItem('empid', empid)
    localStorage.setItem('idUsuario', idUsuario)

    // Update token getter for httpService
    setTokenGetter(() => token)
  }

  const updateUserData = (userData) => {
    // Update context state
    setLoginDataContext((prevState) => ({
      ...prevState,
      ...userData
    }))
  }

  const logout = () => {
    setToken('')
    setIsAuthenticated(false)
    setLoginDataContext({
      tipo: '',
      nombre: '',
      apellido: '',
      registradoParticular: false,
      tipoUsuario: '',
      idUsuario: null,
      cuit: ''
    })
    localStorage.clear()
  }

  const renewToken = async (usuario, empid, refreshToken) => {
    try {
      const loginData = {
        usuario: usuario || localStorage.getItem('usuario'),
        empid: empid || localStorage.getItem('empid'),
        refreshToken: refreshToken || localStorage.getItem('refreshToken')
      }
      const { data } = await loginService.requestToken(loginData)
      if (data.token !== '') {
        setLocalStorage(
          data.token,
          data.refreshToken,
          data.usuario,
          data.empid,
          data.idUsuario,
          data.cuit
        )
      }
    } catch (error) {
      const mensaje = `Ocurrió un error al renovar el token.`
      toastErrorLog(error, mensaje, 'login')
    }
  }

  return (
    <LoginContext.Provider
      value={{
        loginDataContext,
        token,
        isAuthenticated,
        setLocalStorage,
        logout,
        renewToken,
        setLoginDataContext,
        updateUserData,
        setLoginData
      }}
    >
      {props.children}
    </LoginContext.Provider>
  )
}

LoginProvider.propTypes = {
  children: PropTypes.node.isRequired
}
